export const { format: formatNorwegianDate } = new Intl.DateTimeFormat(
  "nb-NO",
  {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
);
